import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./Participant.API";

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
}

class ParticipantStore {

  @observable listParticipant = [];

  getList = async (projectId) => {
      const res = await api.list(projectId);
      const json = await res.json();
      return json.data;
  };

  create = async (data) => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  delete = async (data) => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };
}

const participantStore = new ParticipantStore();

export default participantStore;



// WEBPACK FOOTER //
// ./src/services/participant/Participant.Store.js